export const getS3Url = (key: string) =>
  `https://${import.meta.env.VITE_S3_BUCKET_NAME}.s3.eu-west-3.amazonaws.com/${key}`;
